'use client';
import Button from '@/components/Button';
import { DevelocityLogo } from '@/components/Logos';
import LottieWrapper, { LottieWrapperProps } from '@/components/LottieWrapper';
import { ReactNode } from 'react';

type PillarHeroProps = {
  animationData: LottieWrapperProps['animationData'];
  title: string;
  description: string;
  link: {
    href: string;
    text: string;
    target?: string;
  };
  postHero?: ReactNode;
};

export default function PillarHero({ title, description, animationData, link, postHero }: PillarHeroProps) {
  return (
    <section
      id="hero"
      className="!scroll-mt-[var(--develocityPagesSubNavHeight)] bg-gray-1 px-4 pt-20 text-white md:px-10"
    >
      <div className="max-w-section flex flex-col items-center text-center">
        <DevelocityLogo className="mb-4 h-4" />

        <h1 className="text-h1 mb-4">{title}</h1>
        <p className="text-eyebrow mb-10 max-w-prose text-gray-4">{description}</p>
        <Button variant="ghost-light" outline href={link.href}>
          {link.text}
        </Button>
        <div className="h-[450px] overflow-y-clip md:h-[600px]">
          <LottieWrapper animationData={animationData} autoPlay={true} loop={false} initialSegment={[0, 98]} />
        </div>
        {postHero}
      </div>
    </section>
  );
}
